import {
  basicPolicyFields,
  applicantFields, 
  basicBeneficiaryFields, 
  basicContactFields,
  basicCoverageFields,
  detailedBeneficiaryFields,
  premiumField,
  emailNotificationFields,
  feeRefundFields,
  paymentNotificationFields,
} from './fields';

import {provinces} from '../helpers/provinces';

import { getClientConfig, getClientExpandedGroup } from './clients';
// import clientName from './clients';

function getClientFieldGroup(clientName, fieldGroup) {
  // return getClientFieldConfig(clientName)[fieldGroup] || [];
  return getClientConfig(clientName)[fieldGroup] || [];
}

// function getClientFieldConfig(clientName) {
//   return getClientConfig(clientName);
// }

export function compactGroups(referrerLabel = 'Referrer') {
  return [
    policyGroupCompact(),
    insuredPersonGroupCompact(),
    detailsGroupCompact(referrerLabel),
  ];
}

export function configurationForm(clientName) {
  return {
    compact: compactGroups(),
    expanded: getClientExpandedGroup(clientName),
    quote: quoteGroups(clientName)
  }
}

export function policyGroup(clientName, referrerLabel = 'Referrer') {
  return {
    group_name: 'Policy Information',
    check_history: true,
    fields: [
      ...basicPolicyFields(referrerLabel),
      ...getClientFieldGroup(clientName, 'policy_fields')
    ]
  };
}

export function primaryApplicantDetailsGroup(clientName) {
  return {
    group_name: 'Primary Insured Person',
    check_history: true,
    fields: [
      ...applicantFields('0'),
      ...getClientFieldGroup(clientName, 'primary_applicant_fields'),
      ...premiumField('0'),
    ]
  };
}

export function emailNotificationGroup() {
  return {
    group_name: 'Email Notification',
    check_history: true,
    hidden: true,
    fields: [
      ...emailNotificationFields(),
    ]
  };
}

export function feeRefundGroup() {
  return {
    group_name: 'Fee Refund',
    check_history: true,
    hidden: true,
    fields: [
      ...feeRefundFields(),
    ]
  };
}

export function contactDetailsGroup(clientName) {
  return {
    group_name: 'Contact Information',
    check_history: true,
    fields: [
      ...basicContactFields(),
      ...getClientFieldGroup(clientName, 'contact_details_fields')
    ]
  };
}

export function dependentDetailsGroup(clientName) {
  return {
    group_name: 'Insured Person *++',
    check_history: true,
    repeat: {
      start: 1,
      key_path: ['applicant']
    },
    fields: [
      ...getClientFieldGroup(clientName, 'dependent_fields'),
      ...premiumField('*'),
    ]
  };
}

export function coverageDetailsGroup(clientName) {
  return {
    group_name: 'Coverage Details',
    check_history: true,
    fields_affect_premium: true,
    fields: [
      ...basicCoverageFields(),
      ...getClientFieldGroup(clientName, 'coverage_fields'),
    ]
  };
}

export function beneficiaryGroup() {
  return {
    group_name: 'Beneficiary Information',
    check_history: true,
    fields: [
      ...basicBeneficiaryFields()
    ]
  };
}

export function detailedBeneficiaryGroup() {
  return {
    group_name: 'Beneficiary Details',
    check_history: true,
    fields: [
      ...basicBeneficiaryFields(),
      ...detailedBeneficiaryFields(),
    ]
  };
}

export function paymentGroup(clientName) {
  return {
    group_name: 'Premium / Payment Info',
    check_history: true,
    restricted_access: ['viewonly'],
    fields: [
      {
        key_path: ['application', 'premium'],
        as: 'Premium',
        format: 'currency',
        editable_if_override: true
      },
      {
        key_path: [ 'application', 'additional_data', 'payment_option'],
        as: 'Payment Option',
        type: 'dropdown',
        is_static_by_default: true,
        options: [
          {value: 'lumpsum', text: 'Lump Sum'},
          {value: 'monthly', text: 'Monthly'}
        ],
        show_if: [{
          key_path: [ 'application', 'additional_data', 'payment_option'],
          value: 'lumpsum'
        }]
      },
      {
        key_path: [ 'application', 'additional_data', 'payment_option'],
        as: 'Payment Option',
        type: 'dropdown',
        options: [
          {value: 'lumpsum', text: 'Lump Sum'},
          {value: 'monthly', text: 'Monthly'}
        ],
        show_if: [{
          key_path: [ 'application', 'additional_data', 'payment_option'],
          value: 'monthly'
        }]
      },
      ...getClientFieldGroup(clientName, 'payment_fields'),
    ],
    addon: {
      name: 'payment'
    }
  };
}

export function fulfillmentGroup(hideAutomaticCc = false) {
  return {
    group_name: 'Fulfillment',
    show_only_when: 'view',
    hide_automatic_cc: hideAutomaticCc,
    has_agent_cc: true,
    addon: {
      name: 'email'
    }
  };
}

export function renewalGroup() {
  return {
    group_name: 'Renewal',
    restricted_access: ['viewonly'],
    fields: [
      {
        key_path: ['application', 'additional_data','automatic_renewal_notice'],
        as: 'Auto Renewal Notice',
        type: 'radio',
        options: [
          {value: 'yes', text: 'Yes'},
          {value: 'no', text: 'No'}
        ]
      }
    ],
    addon: {
      name: 'renewal'
    }
  };
}

export function claimsGroup() {
  return{
    group_name: 'Claims',
    addon: {
      name: 'claim'
    }
  };
}

export function notesGroup() {
  return{
    group_name: 'Notes',
    addon: {
      name: 'note'
    }
  };
}

export function attachmentGroup() {
  return {
    group_name: 'Attachments',
    addon: {
      name: 'attachment'
    }
  };
}

export function historyGroup() {
  return {
    group_name: 'History',
    addon: {
      name: 'history'
    }
  };
}

export function policyGroupCompact() {
  return {
    group_name: 'Policy Information',
    check_history: true,
    fields: [
      {
        as: 'Status',
        type: 'custom:status',
        args: {
          key_paths: {
            is_active: ['search', 'application', 'active'],
            effective_date: ['search', 'application', 'effective_date'],
            expiry_date: ['search', 'application', 'expiry_date'],
            status: ['search', 'application', 'status']
          }
        }
      }
    ]
  };
}

export function insuredPersonGroupCompact() {
  return {
    group_name: 'Insured Person',
    fields: [
      {
        key_path: ['search', 'first_name'],
        as: 'First Name'
      },
      {
        key_path: ['search', 'last_name'],
        as: 'Last Name'
      },
      {
        key_path: ['search', 'dob'],
        as: 'Date of Birth',
        format: 'date'
      }
    ]
  };
}

export function detailsGroupCompact(referrerLabel) {
  return {
    group_name: 'Details',
    fields: [
      {
        key_path: ['search', 'application', 'sale_date'],
        as: 'Sale Date',
        format: 'date'
      },
      {
        key_path: ['search', 'application', 'effective_date'],
        as: 'Effective Date',
        format: 'date'
      },
      {
        key_path: ['search', 'application', 'expiry_date'],
        as: 'Expiry Date',
        format: 'date'
      },
      {
        key_path: ['search', 'application', 'additional_data', 'tracking_code'],
        as: referrerLabel,
        is_static_by_default: true
      }
    ]
  };
}

export function associatedGroup() {
  return [
    {
      group_name: 'Associated Policies',
      show_if: [
        {
          key_path: ['application', 'associated_policy'],
          value: null
        },{
          key_path: ['associatedapplicant', '0', 'primary_applicant'],
          value: true
        }
      ],
      fields: [],
      addon: {
        name: 'associated'
      }
    }
  ];
}



function quoteGroups(clientName) {
  return [
    quoteInformationGroup(),
    primaryApplicantDetailsQuoteGroup(),
    coverageDetailsGroup(clientName),
  ];
}



function quoteInformationGroup() {
  return {
    group_name: 'Quote Information',
    check_history: true,
    static_text: 'Note: Rates are subject to change and will be calculated at the time of purchase.',
    fields: [
      {
        key_path: ['application', 'reference_id'],
        as: 'Quote Number'
      },
      {
        key_path: ['application', 'created_at'],
        as: 'Quote Date',
        format: 'date',
      },
      {
        key_path: ['application', 'quote_expiry_date'],
        as: 'Quote Expiry Date',
        format: 'date',
      },
      {
        key_path: ['application', 'quote_status'],
        as: 'Quote Status',
      },
      {
        key_path: ['application', 'quote_form_link'],
        as: 'Quote Link - Editable',
        format: 'link',
        show_if: [{
          key_path: ['application', 'quote_status'],
          value: 'Active'
        }]
      },
      {
        key_path: ['application', 'quote_form_link_read_only'],
        as: 'Quote Link - Read Only',
        format: 'link',
        show_if: [{
          key_path: ['application', 'quote_status'],
          value: 'Active'
        }],
        do_not_show_if: [{
          key_path: ['application', 'additional_data', 'affiliate_code'],
          values: ['RIMI', '2 Visit Canada Inc.', 'insurecanada']
        }]
      },
      {
        key_path: ['application', 'additional_data', 'tracking_code'],
        as: 'Agent Code'
      },
      {
        key_path: ['application', 'additional_data', 'quote_premium'],
        as: 'Quoted Premium',
        format: 'currency',
        do_not_show_if: [{
          key_path: ['application', 'additional_data', 'quote_premium'],
          value: undefined
        }]
      },
      {
        key_path: ['application', 'additional_data', 'sales_tax'],
        as: 'Sales Tax',
        format: 'currency',
        do_not_show_if: [{
          key_path: ['application', 'additional_data', 'sales_tax'],
          value: undefined
        }]
      },
    ]
  };
}

// function primaryApplicantDetailsQuoteGroup() {
//   return {
//     group_name: 'Primary Applicant',
//     check_history: true,
//     fields: [
//       {
//         key_path: ['application', 'additional_data', 'applicants', '0', 'first_name'],
//         as: 'First Name'
//       },
//       {
//         key_path: ['application', 'additional_data', 'applicants', '0', 'last_name'],
//         as: 'Last Name'
//       },
//       {
//         key_path: ['application', 'additional_data', 'applicants', '0', 'dob'],
//         as: 'Date of Birth'
//       },
//       {
//         key_path: ['application', 'additional_data', 'applicants', '0', 'email'],
//         as: 'Email'
//       },
//       {
//         key_path: ['application', 'additional_data', 'state'],
//         as: 'Province of Residence',
//         type: 'dropdown',
//         options: provinces('CA'),
//         do_not_show_if: [{
//           key_path: ['application', 'additional_data', 'state'],
//           value: undefined
//         }]
//       }
//     ]
//   };
// }

function primaryApplicantDetailsQuoteGroup() {
  return {
    group_name: 'Applicant *++',
    check_history: false,
    repeat: {
      start: 0,
      key_path: ['application', 'additional_data', 'applicants']
    },         
    fields: [
      {
        key_path: ['application', 'additional_data', 'applicants', '*', 'first_name'],
        as: 'First Name'
      },
      {
        key_path: ['application', 'additional_data', 'applicants', '*', 'last_name'],
        as: 'Last Name'
      },
      {
        key_path: ['application', 'additional_data', 'applicants', '*', 'dob'],
        as: 'Date of Birth'
      },
      {
        key_path: ['application', 'additional_data', 'applicants', '*', 'email'],
        as: 'Email'
      },
      {
        key_path: ['application', 'additional_data', 'state'],
        as: 'Province of Residence',
        type: 'dropdown',
        options: provinces('CA'),
        do_not_show_if: [{
          key_path: ['application', 'additional_data', 'state'],
          value: undefined
        }]
      }
    ]
  };
}

export function pmqGroup() {
  return {
    group_name: 'Policy Modification Questionnaire',
    columns: 1,
     show_if: [{
       key_paths: {
         expiry_date: ['application', 'expiry_date'],
         effective_date: ['application', 'effective_date'],
         country_of_origin: ['application', 'country_of_origin']
       },
      function: 'modifypolicy'
    }],
    fields: [
      {
        key_path: ['application', 'additional_data', 'pmq', '1'],
        as: '1. Have the Insured Persons had to seek medical attention since arrival?',
        type: 'dropdown',
        options: [
          {value: 1, text: 'Yes'},
          {value: 0, text: 'No'}
        ]
      },
      {
        key_path: ['application', 'additional_data', 'pmq', '2'],
        as: '2. Do Insured Persons know of any reason to seek medical attention?',
        type: 'dropdown',
        options: [
          {value: 1, text: 'Yes'},
          {value: 0, text: 'No'}
        ]
      },
      {
        key_path: ['application', 'additional_data', 'pmq', '3'],
        as: '3. Have any claims been submitted or are there any reasons for which a claim will be submitted?',
        type: 'dropdown',
        options: [
          {value: 1, text: 'Yes'},
          {value: 0, text: 'No'}
        ]
      },
      {
        key_path: ['application', 'additional_data', 'pmq', 'modifypolicy'],
        is_static_by_default: true
      }
    ],
  }
}

export function bqGroup() {
  return {
    group_name: 'Backdating Questionnaire',
    columns: 1,
     show_if: [{
      key_path: ['application', 'effective_date'],
      function: 'backdate'
    }],
    fields: [
      {
        key_path: ['application', 'additional_data', 'bq', '1'],
        as: '1. Have the Insured Persons had to seek medical attention since arrival?',
        type: 'dropdown',
        options: [
          {value: 1, text: 'Yes'},
          {value: 0, text: 'No'}
        ]
      },
      {
        key_path: ['application', 'additional_data', 'bq', '2'],
        as: '2. Do Insured Persons know of any reason to seek medical attention?',
        type: 'dropdown',
        options: [
          {value: 1, text: 'Yes'},
          {value: 0, text: 'No'}
        ]
      },
      {
        key_path: ['application', 'additional_data', 'bq', '3'],
        as: '3. Have any claims been submitted or are there any reasons for which a claim will be submitted?',
        type: 'dropdown',
        options: [
          {value: 1, text: 'Yes'},
          {value: 0, text: 'No'}
        ]
      },
      {
        key_path: ['application', 'additional_data', 'bq', 'backdating'],
        is_static_by_default: true,
      }
    ],
  }
}

export function mqGroup() {
  return {
    group_name: 'MQ Answers 2 - Insured Person *++',
    fields_affect_premium: true,
    columns: 1,
    repeat: {
      start: 0,
      key_path: ['applicant']
    },
    show_if: [{
      key_path: ['applicant', '*', 'additional_data', 'pe_coverage'],
      value: 'yes'
    },{
      key_path: ['applicant', '*', 'dob'],
      original_age: ['applicant', '*', 'additional_data', 'original_age_limit'],
      function: 'age'
    },{
      key_path: ['application', 'sale_date'],
      function: 'newmq'
    }],
    fields: [
      {
        key_path: ['applicant', '*', 'additional_data', 'mq', 'mq1'],
        as: '1. Was your most recent heart bypass, heart angioplasty (including stent placement) or heart valve surgery more than 10 years prior to your effective date?',
        type: 'dropdown',
        options: [
          {value: 1, text: 'Yes'},
          {value: 0, text: 'No'}
        ]
      },
      {
        key_path: ['applicant', '*', 'additional_data', 'mq', 'mq2'],
        as: '2. Have you been diagnosed with a heart condition as well as diabetes and/or hypertension (high blood pressure)? Answer NO if you have only diabetes/hypertension and do not have a heart condition.',
        type: 'dropdown',
        options: [
          {value: 1, text: 'Yes'},
          {value: 0, text: 'No'}
        ]
      },
      {
        key_path: ['applicant', '*', 'additional_data', 'mq', 'mq3'],
        as: '3. Have you ever had or are you awaiting a bone marrow or organ transplant?',
        type: 'dropdown',
        options: [
          {value: 1, text: 'Yes'},
          {value: 0, text: 'No'}
        ]
      },
      {
        key_path: ['applicant', '*', 'additional_data', 'mq', 'mqna'],
        as: '4. In the 24 months prior to your effective date have you been diagnosed with or treated for:',
        is_static_by_default: true
      },
      {
        key_path: ['applicant', '*', 'additional_data', 'mq', 'mq4'],
        as: 'a) congestive heart failure?',
        type: 'dropdown',
        options: [
          {value: 1, text: 'Yes'},
          {value: 0, text: 'No'}
        ]
      },
      {
        key_path: ['applicant', '*', 'additional_data', 'mq', 'mq5'],
        as: 'b) a lung condition with prednisone or other oral steroid medication (not including puffer) or home oxygen?',
        type: 'dropdown',
        options: [
          {value: 1, text: 'Yes'},
          {value: 0, text: 'No'}
        ]
      },
      {
        key_path: ['applicant', '*', 'additional_data', 'mq', 'mq6'],
        as: 'c) kidney or liver failure?',
        type: 'dropdown',
        options: [
          {value: 1, text: 'Yes'},
          {value: 0, text: 'No'}
        ]
      },
      {
        key_path: ['applicant', '*', 'additional_data', 'mq', 'mq7'],
        as: 'd) peripheral vascular disease?',
        type: 'dropdown',
        options: [
          {value: 1, text: 'Yes'},
          {value: 0, text: 'No'}
        ]
      },
      {
        key_path: ['applicant', '*', 'additional_data', 'mq', 'mqna'],
        as: '5. In the 12 months prior to your effective date have you been diagnosed with or been treated for:',
        is_static_by_default: true
      },
      {
        key_path: ['applicant', '*', 'additional_data', 'mq', 'mq8'],
        as: 'a) angina, chest pain or a heart attack?',
        type: 'dropdown',
        options: [
          {value: 1, text: 'Yes'},
          {value: 0, text: 'No'}
        ]
      },
      {
        key_path: ['applicant', '*', 'additional_data', 'mq', 'mq9'],
        as: 'b) stroke, transient ischemic attack (TIA)or mini-stroke?',
        type: 'dropdown',
        options: [
          {value: 1, text: 'Yes'},
          {value: 0, text: 'No'}
        ]
      },
      {
        key_path: ['applicant', '*', 'additional_data', 'mq', 'mq10'],
        as: 'c) cancer (excluding basal or squamous cell skin cancer or breast cancer treated only with hormone therapy)?',
        type: 'dropdown',
        options: [
          {value: 1, text: 'Yes'},
          {value: 0, text: 'No'}
        ]
      },
      {
        key_path: ['applicant', '*', 'additional_data', 'mq', 'mq11'],
        as: 'd) internal bleeding?',
        type: 'dropdown',
        options: [
          {value: 1, text: 'Yes'},
          {value: 0, text: 'No'}
        ]
      },
    ],
  };
}

export function mqGroupOld() {
  return {
    group_name: 'MQ Answers - Insured Person *++',
    fields_affect_premium: true,
    columns: 1,
    repeat: {
      start: 0,
      key_path: ['applicant']
    },
    show_if: [{
      key_path: ['applicant', '*', 'additional_data', 'pe_coverage'],
      value: 'yes'
    },{
      key_path: ['applicant', '*', 'dob'],
      original_age: ['applicant', '*', 'additional_data', 'original_age_limit'],
      function: 'age'
    },{
      key_path: ['application', 'sale_date'],
      function: 'oldmq'
    }],
    fields: [
      {
        key_path: ['applicant', '*', 'additional_data', 'mq', 'mq1'],
        as: '1. Was your most recent heart bypass, heart angioplasty (including stent placement) or heart valve surgery more than 10 years prior to your effective date?',
        type: 'dropdown',
        options: [
          {value: 1, text: 'Yes'},
          {value: 0, text: 'No'}
        ]
      },
      {
        key_path: ['applicant', '*', 'additional_data', 'mq', 'mq2'],
        as: '2. Have you been diagnosed with a heart condition as well as diabetes and/or hypertension (high blood pressure)?',
        type: 'dropdown',
        options: [
          {value: 1, text: 'Yes'},
          {value: 0, text: 'No'}
        ]
      },
      {
        key_path: ['applicant', '*', 'additional_data', 'mq', 'mq3'],
        as: '3. Have you ever had or are you awaiting a bone marrow or organ transplant?',
        type: 'dropdown',
        options: [
          {value: 1, text: 'Yes'},
          {value: 0, text: 'No'}
        ]
      },
      {
        key_path: ['applicant', '*', 'additional_data', 'mq', 'mqna'],
        as: '4. In the 24 months prior to your effective date have you been diagnosed with or treated for:',
        is_static_by_default: true
      },
      {
        key_path: ['applicant', '*', 'additional_data', 'mq', 'mq4'],
        as: 'a) congestive heart failure?',
        type: 'dropdown',
        options: [
          {value: 1, text: 'Yes'},
          {value: 0, text: 'No'}
        ]
      },
      {
        key_path: ['applicant', '*', 'additional_data', 'mq', 'mq5'],
        as: 'b) a lung condition with prednisone (or other oral steroid medication) or home oxygen?',
        type: 'dropdown',
        options: [
          {value: 1, text: 'Yes'},
          {value: 0, text: 'No'}
        ]
      },
      {
        key_path: ['applicant', '*', 'additional_data', 'mq', 'mq6'],
        as: 'c) kidney or liver failure?',
        type: 'dropdown',
        options: [
          {value: 1, text: 'Yes'},
          {value: 0, text: 'No'}
        ]
      },
      {
        key_path: ['applicant', '*', 'additional_data', 'mq', 'mq7'],
        as: 'd) peripheral vascular disease?',
        type: 'dropdown',
        options: [
          {value: 1, text: 'Yes'},
          {value: 0, text: 'No'}
        ]
      },
      {
        key_path: ['applicant', '*', 'additional_data', 'mq', 'mqna'],
        as: '5. In the 12 months prior to your effective date have you been diagnosed with or been treated for:',
        is_static_by_default: true
      },
      {
        key_path: ['applicant', '*', 'additional_data', 'mq', 'mq8'],
        as: 'a) angina, chest pain or a heart attack?',
        type: 'dropdown',
        options: [
          {value: 1, text: 'Yes'},
          {value: 0, text: 'No'}
        ]
      },
      {
        key_path: ['applicant', '*', 'additional_data', 'mq', 'mq9'],
        as: 'b) stroke, transient ischemic attack (TIA)or mini-stroke?',
        type: 'dropdown',
        options: [
          {value: 1, text: 'Yes'},
          {value: 0, text: 'No'}
        ]
      },
      {
        key_path: ['applicant', '*', 'additional_data', 'mq', 'mq10'],
        as: 'c) cancer (excluding basal or squamous cell skin cancer or breast cancer treated only with hormone therapy)?',
        type: 'dropdown',
        options: [
          {value: 1, text: 'Yes'},
          {value: 0, text: 'No'}
        ]
      },
      {
        key_path: ['applicant', '*', 'additional_data', 'mq', 'mq11'],
        as: 'd) internal bleeding?',
        type: 'dropdown',
        options: [
          {value: 1, text: 'Yes'},
          {value: 0, text: 'No'}
        ]
      },
    ],
  };
}





// WEBPACK FOOTER //
// ./src/helpers/fieldGroups.js